import { guestLinks } from '@map/components/GuestArea/links';
import { buildApiUrl } from '@map/hooks/baseApi';
import { useShowMessage } from '@map/hooks/notifications';
import { windowExtended } from '@map/types';
import { sanitizeUsername } from '@map/validators/user';
import { useFormatMessage } from '@shared/hooks/intl';
import useLocationState from '@shared/hooks/useLocationState';
import useNavigate from '@shared/hooks/useNavigate';
import Form from '@shared/lib/form/Form';
import Yup from '@shared/lib/yupWithCustomValidations';
import axios from 'axios';
import { Route, Switch } from 'react-router-dom';
import ForgotPasswordForm from './ForgotPasswordForm';
import ForgotPasswordViaEmail from './ForgotPasswordViaEmail';
import ForgotPasswordViaPhone from './ForgotPasswordViaPhone';

const validationSchema = Yup.object({
  username: Yup.string().notBlank().validUsername(),
});

const ForgotPassword = () => {
  const navigate = useNavigate();
  const t = useFormatMessage();
  const showMessage = useShowMessage();
  const { project } = windowExtended;
  const [username] = useLocationState('username', '');

  const handleSubmit = async ({ username }: { username: string }) => {
    try {
      const sanitizedUsername = sanitizeUsername(username);
      const { data } = await axios.post<{ type?: 'email' | 'phone' | 'invalid'; error?: string }>(
        buildApiUrl('password_reset'),
        { username: sanitizedUsername, project: project.slug },
      );
      if (data.type === 'phone') {
        navigate(guestLinks.forgotPasswordPhone(), { state: { username: sanitizedUsername } });
      } else if (data.type === 'email') {
        navigate(guestLinks.forgotPasswordEmail(), { state: { username } });
      } else if (data.type === 'invalid') {
        showMessage({ type: 'error', text: t('forgot_password.invalid_username') });
      }
      return data.error;
    } catch (e) {
      console.warn(e);
    }
  };
  return (
    <Switch>
      <Route path={guestLinks.forgotPasswordPhone()}>
        <ForgotPasswordViaPhone />
      </Route>
      <Route path={guestLinks.forgotPasswordEmail()}>
        <ForgotPasswordViaEmail onSubmit={handleSubmit} />
      </Route>
      <Route path={guestLinks.forgotPassword()}>
        <Form
          onSubmit={handleSubmit}
          initialValues={{ username: username || '' }}
          validationSchema={validationSchema}
        >
          <ForgotPasswordForm />
        </Form>
      </Route>
    </Switch>
  );
};

export default ForgotPassword;
